package com.essntl.features.customfields.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import com.essntl.features.customfields.domain.model.CustomFieldsModel.CommissionType
import com.essntl.features.customfields.ui.components.CommissionTypeDropDown
import com.essntl.features.organization.domain.model.OrganizationModel
import com.essntl.uikit.components.dropdown.EsInputDropdownMenu
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme

@Composable
fun CustomFieldsScreen(
    state: CustomFieldsState,
    onEvent: (CustomFieldsEvent) -> Unit,
) {
    val isLoading = remember(state) { state.isLoading }

    val customFields = state.customFields.value

    Column(
        verticalArrangement = Arrangement.Center,
        modifier = Modifier
            .fillMaxSize()
            .background(
                color = MaterialTheme.esColorScheme.bgSecondary,
                shape = RoundedCornerShape(EsConstants.RoundedCornerSize),
            )
            .clip(
                RoundedCornerShape(
                    topStart = 24.dp,
                    topEnd = 24.dp,
                ),
            )
            .padding(
                horizontal = 2.5f.spacing,
                vertical = 2.spacing,
            ),
    ) {
        if (isLoading)
            EsSpinner()
        else {
            if (state.type == OrganizationModel.Type.TravelAgency) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(2.spacing),
                    modifier = Modifier.fillMaxWidth(),
                ) {
                    EsInput(
                        value = customFields.commission?.let { if (it > 0) "$it" else "" }.orEmpty(),
                        placeholder = "Commission %",
                        label = "Enter the commission %",
                        onValueChange = {
                            val commission: Number = it.toDoubleOrNull() ?: return@EsInput
                            onEvent(
                                CustomFieldsEvent.UpdateCustomFields(
                                    customFields.copy(
                                        commission = commission.toDouble(),
                                    ),
                                ),
                            )
                        },
                        keyboardOptions =
                            KeyboardOptions(
                                keyboardType = KeyboardType.Number,
                            ),
                        modifier = Modifier.weight(3f),
                        enabled = customFields.commissionType != CommissionType.Net,
                    )

                    CommissionTypeDropDown(
                        commissionType = customFields.commissionType,
                        onCommissionTypeSelected = { newCommissionType ->
                            if (newCommissionType != customFields.commissionType) {
                                val newCommission = if (newCommissionType == CommissionType.Net) null else customFields.commission
                                onEvent(
                                    CustomFieldsEvent.UpdateCustomFields(
                                        customFields.copy(
                                            commissionType = newCommissionType,
                                            commission = newCommission,
                                        ),
                                    ),
                                )
                            }
                        },
                        modifier = Modifier
                            .padding(top = 3f.spacing)
                            .weight(1f),
                    )
                }

                Spacer(modifier = Modifier.height(2.spacing))

                EsInput(
                    value = customFields.source ?: "",
                    onValueChange = {
                        onEvent(
                            CustomFieldsEvent.UpdateCustomFields(
                                customFields.copy(
                                    source = it,
                                ),
                            ),
                        )
                    },
                    placeholder = "Enter Source",
                    label = "Source",
                )

            } else if (state.type == OrganizationModel.Type.Supplier) {

                Spacer(modifier = Modifier.height(2.spacing))

                EsInputDropdownMenu(
                    items = state.getAllCategory.data.orEmpty().sortedBy { it.name },
                    selectedItem = customFields.category,
                    text = { it.name },
                    onItemSelected = {
                        onEvent(
                            CustomFieldsEvent.UpdateCustomFields(
                                customFields.copy(
                                    category = it,
                                ),
                            ),
                        )
                    },
                    label = "Category",
                    placeholder = "Select Category",
                    modifier =
                        Modifier.offset(
                            x = 0.dp,
                            y = (-20).dp,
                        ),
                )

                Spacer(modifier = Modifier.height(1.spacing))

                EsInputDropdownMenu(
                    items = state.getAllArea.data.orEmpty().sortedBy { it.name },
                    selectedItem = customFields.area,
                    text = { it.name ?: "" },
                    onItemSelected = {
                        onEvent(
                            CustomFieldsEvent.UpdateCustomFields(
                                customFields.copy(
                                    area = it,
                                ),
                            ),
                        )
                    },
                    label = "Area",
                    placeholder = "Select Area",
                    modifier =
                        Modifier.offset(
                            x = 0.dp,
                            y = (-20).dp,
                        ),
                )

                EsInput(
                    value = customFields.description.orEmpty(),
                    onValueChange = {
                        onEvent(
                            CustomFieldsEvent.UpdateCustomFields(
                                customFields.copy(
                                    description = it,
                                ),
                            ),
                        )
                    },
                    placeholder = "Enter description",
                    label = "Description",
                )
            }
        }
    }
}
